<div class="title pw-2">
    <a :href="column.data.link" target="_blank">
        {{ title }}
        <div v-if="!!region" class="title__region">{{ region }}</div>
    </a>
</div>
